import React, { useCallback, useState, useContext } from 'react';
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaBan, FaRegCalendarAlt } from "react-icons/fa";

import CreateBatchAssignation from './CreateBatchAssignation';
import ShowBatchAssignation from './ShowBatchAssignation';
import StoreSelector from "../Layout/StoreSelector";
import BatchAssignationHistory from "./BatchAssignationHistory";

import { SiteContext } from "../../context/SiteContext";
import { UserContext } from "../../context/UserContext";

import { getInventoryStores } from "../../helpers/Stores";

const BatchAssignationsModal = ({batchAssignation, setBatchAssignation}) => {
    const { env, csrfToken } = useContext(SiteContext);
    const { user } = useContext(UserContext);

    const [store, setStore] = useState("101");
    const [uploading, setUploading] = useState(false);
    const [batchAssignationId, setBatchAssignationId] = useState(null);
    const [infoModalData, setInfoModalData] = useState({});
    const [showHistory, setShowHistory] = useState(false);

    const hideInfoModal = useCallback(
        () => {
            setInfoModalData(infoModalData => ({
                ...infoModalData,
                show: false,
            }));
        }, []
    );

    const showInfoModal = useCallback(
        (infoModalData) => {
            setInfoModalData({
                ...infoModalData,
                show: true
            });
        }, []
    );

    const resetBatchAssignation = useCallback(
        () => {
            setBatchAssignationId(null);
            setInfoModalData({});
        }, []
    );

    const handleFileUpload = useCallback(
        (file) => {
            setShowHistory(false);

            if (!file) {
                return;
            }

            if (!["text/plain", "text/csv"].includes(file.type)) {
                showInfoModal({
                    type: "error",
                    msg: "Formato no soportado",
                });
                return;
            }

            setUploading(true);

            showInfoModal({
                type: "loading",
                msg: "Subiendo archivo para picking masivo",
                closeButton: false,
            });

            const formData = new FormData();
            formData.append(
                "picking",
                file,
                file.name
            );

            const url = env.webApiBaseUrl + "/batchAssignations/by-store/" + 
                    encodeURIComponent(store);
            axios
                .post(url, formData, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-Token": csrfToken,
                        Authorization: "Bearer " + user.token,
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const batchAssignationId = response.data._id;
                    setBatchAssignationId(batchAssignationId);
                    hideInfoModal();
                })
                .catch((error) => {
                    console.error(error);
                    showInfoModal({
                        type: "error",
                        msg: "No pude subir el archivo",
                        retryButton: true,
                    });
                })
                .finally(() => {
                    setUploading(false);
                });
        }, [showInfoModal, env.webApiBaseUrl, store, csrfToken, user.token, hideInfoModal]
    );

    return (
        <Modal 
            size="lg"
            backdrop="static"
            show={batchAssignation} 
            onHide={() => setBatchAssignation(false)}
            onExited={() => resetBatchAssignation()}
        >
            <Modal.Header>
            <Modal.Title className="flex-grow-1">
                PICKING MASIVO
            </Modal.Title>

            <div>
                <Button
                    variant="danger"
                    className="float-end ms-2 mt-1 mb-2"
                    onClick={() => setBatchAssignation(false)}
                >
                    <FaBan style={{ marginBottom: "3px" }} />
                </Button>
                <StoreSelector
                    className="float-end ms-2 mt-1 mb-2"
                    store={store}
                    availableStores={getInventoryStores()}
                    setStore={setStore}
                />
                <Button
                    variant="warning"
                    alt="Pickings anteriores"
                    className="float-end ms-2 mt-1 mb-2"
                    active={showHistory}
                    disabled={uploading}
                    onClick={() => setShowHistory(show => !show)}
                >
                    HISTORIAL
                    <FaRegCalendarAlt className="ms-2" style={{ marginBottom: "3px" }} />
                </Button>
            </div>
        </Modal.Header>
            <Modal.Body style={{ minHeight: "40vh", overflowY: "auto", overflowX: "auto" }}>
            {showHistory
            ? <BatchAssignationHistory 
                store={store}
            />
            : null
            }
            {batchAssignationId == null
                ? <CreateBatchAssignation 
                    handleFileUpload={handleFileUpload}
                    uploading={uploading}
                    infoModalData={infoModalData}
                    setInfoModalData={setInfoModalData}
                />
                : <ShowBatchAssignation 
                    id={batchAssignationId}
                />
            }
            </Modal.Body>
        </Modal>
    );
};

export default BatchAssignationsModal;